/* eslint-disable postro4no/object-props */
export const goalkeepersModalParams = [
  {
    checked: true, groupe: 'General', id: 1, label: 'Mins Played', lexic_id: '', name: 'Mins Played', paramId: 1,
  },
  {
    checked: true, groupe: 'General', id: 2, label: 'Goals conceded', lexic_id: '', name: 'Goals conceded', paramId: 173,
  },
  {
    checked: true, groupe: 'General', id: 3, label: 'Goal Mistakes', lexic_id: '', name: 'Goal Mistakes', paramId: 161,
  },
  {
    checked: true, groupe: 'General', id: 4, label: 'Grave Mistakes', lexic_id: '', name: 'Grave Mistakes', paramId: 162,
  },
  {
    checked: true, groupe: 'General', id: 5, label: 'On-Ball Events', lexic_id: '', name: 'On-Ball Events', paramId: 14,
  },
  {
    checked: true, groupe: 'General', id: 6, label: 'On-Ball Events +', lexic_id: '', name: 'On-Ball Events +', paramId: 15,
  },
  {
    checked: true, groupe: 'General', id: 7, label: 'On-Ball Events , %', lexic_id: '', name: 'On-Ball Events , %', paramId: 16,
  },
  {
    checked: true, groupe: 'General', id: 8, label: 'On-Ball Events -', lexic_id: '', name: 'On-Ball Events -', paramId: 17,
  },
  {
    checked: true, groupe: 'General', id: 9, label: 'On-Ball Events - , %', lexic_id: '', name: 'On-Ball Events - , %', paramId: 18,
  },
  {
    checked: true, groupe: 'General', id: 10, label: 'Fouls', lexic_id: '', name: 'Fouls', paramId: 19,
  },
  {
    checked: true, groupe: 'General', id: 11, label: 'Fouls Suffered', lexic_id: '', name: 'Fouls Suffered', paramId: 20,
  },
  {
    checked: true, groupe: 'General', id: 12, label: 'Yellow Cards', lexic_id: '', name: 'Yellow Cards', paramId: 21,
  },
  {
    checked: true, groupe: 'General', id: 13, label: 'Yellow-Red Cards', lexic_id: '', name: 'Yellow-Red Cards', paramId: 22,
  },
  {
    checked: true, groupe: 'General', id: 14, label: 'Red Cards', lexic_id: '', name: 'Red Cards', paramId: 23,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 15, label: 'Opponent\'s shots', lexic_id: '', name: 'Opponent\'s shots', paramId: 171,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 16, label: 'Opponent\'s shots on target', lexic_id: '', name: 'Opponent\'s shots on target', paramId: 172,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 17, label: 'Saved shots', lexic_id: '', name: 'Saved shots', paramId: 174,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 18, label: 'Saved shots , %', lexic_id: '', name: 'Saved shots , %', paramId: 175,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 19, label: 'Super Saves', lexic_id: '', name: 'Super Saves', paramId: 176,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 20, label: 'GK saves with bouncing', lexic_id: '', name: 'GK saves with bouncing', paramId: 196,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 21, label: 'GK saves with bouncing +', lexic_id: '', name: 'GK saves with bouncing +', paramId: 197,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 22, label: 'GK saves with bouncing + , %', lexic_id: '', name: 'GK saves with bouncing + , %', paramId: 198,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 23, label: 'GK saves with bouncing -', lexic_id: '', name: 'GK saves with bouncing -', paramId: 199,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 24, label: 'GK saves with bouncing - , %', lexic_id: '', name: 'GK saves with bouncing - , %', paramId: 200,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 25, label: 'Penalty faced', lexic_id: '', name: 'Penalty faced', paramId: 177,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 26, label: 'Goals conceded from penalty', lexic_id: '', name: 'Goals conceded from penalty', paramId: 178,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 27, label: 'Saved penalties', lexic_id: '', name: 'Saved penalties', paramId: 179,
  },
  {
    checked: true, groupe: 'Shots / Saves', id: 28, label: 'Saved penalties , %', lexic_id: '', name: 'Saved penalties , %', paramId: 180,
  },
  {
    checked: true, groupe: 'GK Actions', id: 29, label: 'GK Interceptions', lexic_id: '', name: 'GK Interceptions', paramId: 181,
  },
  {
    checked: true, groupe: 'GK Actions', id: 30, label: 'GK Interceptions +', lexic_id: '', name: 'GK Interceptions +', paramId: 182,
  },
  {
    checked: true, groupe: 'GK Actions', id: 31, label: 'GK Interceptions , %', lexic_id: '', name: 'GK Interceptions , %', paramId: 183,
  },
  {
    checked: true, groupe: 'GK Actions', id: 32, label: 'GK Interceptions -', lexic_id: '', name: 'GK Interceptions -', paramId: 184,
  },
  {
    checked: true, groupe: 'GK Actions', id: 33, label: 'GK Interceptions - , %', lexic_id: '', name: 'GK Interceptions - , %', paramId: 185,
  },
  {
    checked: true, groupe: 'GK Actions', id: 34, label: 'Clearances', lexic_id: '', name: 'Clearances', paramId: 160,
  },
  {
    checked: true, groupe: 'Passes', id: 35, label: 'Passes', lexic_id: '', name: 'Passes', paramId: 35,
  },
  {
    checked: true, groupe: 'Passes', id: 36, label: 'Passes +', lexic_id: '', name: 'Passes +', paramId: 36,
  },
  {
    checked: true, groupe: 'Passes', id: 37, label: 'Passes +, %', lexic_id: '', name: 'Passes +, %', paramId: 37,
  },
  {
    checked: true, groupe: 'Passes', id: 38, label: 'Passes -', lexic_id: '', name: 'Passes -', paramId: 38,
  },
  {
    checked: true, groupe: 'Passes', id: 39, label: 'Passes - , %', lexic_id: '', name: 'Passes - , %', paramId: 39,
  },
  {
    checked: true, groupe: 'Passes', id: 40, label: 'Passes in challenge', lexic_id: '', name: 'Passes in challenge', paramId: 40,
  },
  {
    checked: true, groupe: 'Passes', id: 41, label: 'Passes in challenge +', lexic_id: '', name: 'Passes in challenge +', paramId: 41,
  },
  {
    checked: true, groupe: 'Passes', id: 42, label: 'Passes in challenge + , %', lexic_id: '', name: 'Passes in challenge + , %', paramId: 42,
  },
  {
    checked: true, groupe: 'Passes', id: 43, label: 'Passes in challenge -', lexic_id: '', name: 'Passes in challenge -', paramId: 43,
  },
  {
    checked: true, groupe: 'Passes', id: 44, label: 'Passes in challenge - , %', lexic_id: '', name: 'Passes in challenge - , %', paramId: 44,
  },
  {
    checked: true, groupe: 'Passes', id: 45, label: 'GK Hand Passes', lexic_id: '', name: 'GK Hand Passes', paramId: 186,
  },
  {
    checked: true, groupe: 'Passes', id: 46, label: 'GK Hand Passes +', lexic_id: '', name: 'GK Hand Passes +', paramId: 187,
  },
  {
    checked: true, groupe: 'Passes', id: 47, label: 'GK Hand Passes + , %', lexic_id: '', name: 'GK Hand Passes + , %', paramId: 188,
  },
  {
    checked: true, groupe: 'Passes', id: 48, label: 'GK Hand Passes -', lexic_id: '', name: 'GK Hand Passes -', paramId: 189,
  },
  {
    checked: true, groupe: 'Passes', id: 49, label: 'GK Hand Passes - , %', lexic_id: '', name: 'GK Hand Passes - , %', paramId: 190,
  },
  {
    checked: true, groupe: 'Passes', id: 50, label: 'GK Goal Kick Passes', lexic_id: '', name: 'GK Goal Kick Passes', paramId: 191,
  },
  {
    checked: true, groupe: 'Passes', id: 51, label: 'GK Goal Kick Passes +', lexic_id: '', name: 'GK Goal Kick Passes +', paramId: 192,
  },
  {
    checked: true, groupe: 'Passes', id: 52, label: 'GK Goal Kick Passes + , %', lexic_id: '', name: 'GK Goal Kick Passes + , %', paramId: 193,
  },
  {
    checked: true, groupe: 'Passes', id: 53, label: 'GK Goal Kick Passes -', lexic_id: '', name: 'GK Goal Kick Passes -', paramId: 194,
  },
  {
    checked: true, groupe: 'Passes', id: 54, label: 'GK Goal Kick Passes - , %', lexic_id: '', name: 'GK Goal Kick Passes - , %', paramId: 195,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 55, label: 'Short Passes', lexic_id: '', name: 'Short Passes', paramId: 55,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 56, label: 'Short Passes +', lexic_id: '', name: 'Short Passes +', paramId: 56,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 57, label: 'Short Passes + , %', lexic_id: '', name: 'Short Passes + , %', paramId: 57,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 58, label: 'Short Passes -', lexic_id: '', name: 'Short Passes -', paramId: 58,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 59, label: 'Short Passes - , %', lexic_id: '', name: 'Short Passes - , %', paramId: 59,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 60, label: 'Middle Passes ', lexic_id: '', name: 'Middle Passes ', paramId: 60,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 61, label: 'Middle Passes +', lexic_id: '', name: 'Middle Passes +', paramId: 61,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 62, label: 'Middle Passes + , %', lexic_id: '', name: 'Middle Passes + , %', paramId: 62,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 63, label: 'Middle Passes  - ', lexic_id: '', name: 'Middle Passes  - ', paramId: 63,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 64, label: 'Middle Passes - , %', lexic_id: '', name: 'Middle Passes - , %', paramId: 64,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 65, label: 'Long Passes', lexic_id: '', name: 'Long Passes', paramId: 65,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 66, label: 'Long Passes +', lexic_id: '', name: 'Long Passes +', paramId: 66,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 67, label: 'Long Passes + , %', lexic_id: '', name: 'Long Passes + , %', paramId: 67,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 68, label: 'Long Passes -', lexic_id: '', name: 'Long Passes -', paramId: 68,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 69, label: 'Long Passes - , %', lexic_id: '', name: 'Long Passes - , %', paramId: 69,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 70, label: 'Short Passes Received', lexic_id: '', name: 'Short Passes Received', paramId: 97,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 71, label: 'Short Passes Received , %', lexic_id: '', name: 'Short Passes Received , %', paramId: 98,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 72, label: 'Middle Passes Received', lexic_id: '', name: 'Middle Passes Received', paramId: 99,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 73, label: 'Middle Passes Received , %', lexic_id: '', name: 'Middle Passes Received , %', paramId: 100,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 74, label: 'Long Passes Received', lexic_id: '', name: 'Long Passes Received', paramId: 101,
  },
  {
    checked: true, groupe: 'Passes by distance', id: 75, label: 'Long Passes Received , %', lexic_id: '', name: 'Long Passes Received , %', paramId: 102,
  },
  {
    checked: true, groupe: 'Passes by side', id: 76, label: 'Passes Forward', lexic_id: '', name: 'Passes Forward', paramId: 70,
  },
  {
    checked: true, groupe: 'Passes by side', id: 77, label: 'Passes Forward +', lexic_id: '', name: 'Passes Forward +', paramId: 71,
  },
  {
    checked: true, groupe: 'Passes by side', id: 78, label: 'Passes Forward + , %', lexic_id: '', name: 'Passes Forward + , %', paramId: 72,
  },
  {
    checked: true, groupe: 'Passes by side', id: 79, label: 'Passes Forward -', lexic_id: '', name: 'Passes Forward -', paramId: 73,
  },
  {
    checked: true, groupe: 'Passes by side', id: 80, label: 'Passes Forward - , %', lexic_id: '', name: 'Passes Forward - , %', paramId: 74,
  },
  {
    checked: true, groupe: 'Passes by side', id: 81, label: 'Passes Backward', lexic_id: '', name: 'Passes Backward', paramId: 75,
  },
  {
    checked: true, groupe: 'Passes by side', id: 82, label: 'Passes Backward +', lexic_id: '', name: 'Passes Backward +', paramId: 76,
  },
  {
    checked: true, groupe: 'Passes by side', id: 83, label: 'Passes Backward +, %', lexic_id: '', name: 'Passes Backward +, %', paramId: 77,
  },
  {
    checked: true, groupe: 'Passes by side', id: 84, label: 'Passes Backward -', lexic_id: '', name: 'Passes Backward -', paramId: 78,
  },
  {
    checked: true, groupe: 'Passes by side', id: 85, label: 'Passes Backward - , %', lexic_id: '', name: 'Passes Backward - , %', paramId: 79,
  },
  {
    checked: true, groupe: 'Passes by side', id: 86, label: 'Passes Sideways', lexic_id: '', name: 'Passes Sideways', paramId: 80,
  },
  {
    checked: true, groupe: 'Passes by side', id: 87, label: 'Passes Sideways +', lexic_id: '', name: 'Passes Sideways +', paramId: 81,
  },
  {
    checked: true, groupe: 'Passes by side', id: 88, label: 'Passes Sideways + , %', lexic_id: '', name: 'Passes Sideways + , %', paramId: 82,
  },
  {
    checked: true, groupe: 'Passes by side', id: 89, label: 'Passes Sideways -', lexic_id: '', name: 'Passes Sideways -', paramId: 83,
  },
  {
    checked: true, groupe: 'Passes by side', id: 90, label: 'Passes Sideways - , %', lexic_id: '', name: 'Passes Sideways - , %', paramId: 84,
  },
  {
    checked: true, groupe: 'Passes by side', id: 91, label: 'Passes Forward Received', lexic_id: '', name: 'Passes Forward Received', paramId: 103,
  },
  {
    checked: true, groupe: 'Passes by side', id: 92, label: 'Passes Forward Received , %', lexic_id: '', name: 'Passes Forward Received , %', paramId: 104,
  },
  {
    checked: true, groupe: 'Passes by side', id: 93, label: 'Passes Backward Received', lexic_id: '', name: 'Passes Backward Received', paramId: 105,
  },
  {
    checked: true, groupe: 'Passes by side', id: 94, label: 'Passes Backward Received , %', lexic_id: '', name: 'Passes Backward Received , %', paramId: 106,
  },
  {
    checked: true, groupe: 'Passes by side', id: 95, label: 'Passes Sideways Received', lexic_id: '', name: 'Passes Sideways Received', paramId: 107,
  },
  {
    checked: true, groupe: 'Passes by side', id: 96, label: 'Passes Sideways Received , %', lexic_id: '', name: 'Passes Sideways Received , %', paramId: 108,
  },
]

